import React from 'react';
import {
  Card,
  CardContent,
  Container,
  Typography
} from '@material-ui/core';

import { FORM_ACTIONS } from 'src/utils/constants/general';
import FormComponentPanelUser from './shared/form';

import ErrorsValidation from '../shared/displayErrorsValidations';
import Page from '../Page';
import PageContainer from 'src/containers/shared/PageContainer';

const FormPanelUser = ({
  action,
  errors,
  loading,
  handlePanelUser,
  panelUser,
  paginasInst,
  portadas
}) => {
  const title = action === FORM_ACTIONS.ADD
    ? `Agregar Panel de Usuario - ${process.env.REACT_APP_NAME}`
    : `Editar Panel de Usuario - ${process.env.REACT_APP_NAME}`;

  const name = action === FORM_ACTIONS.ADD
    ? 'Agregando Panel de Usuario'
    : `Editando Panel de Usuario ${panelUser.name.replace(/<\/?[^>]*>/g, '')}`;

  return (
    <PageContainer title={title} maxWidth={false}>
        <Typography
          color="textPrimary"
          variant="h2"
          className="mb-3"
        >
          {name}
        </Typography>
        <ErrorsValidation errors={errors} />
        <Card>
          <CardContent>
            <FormComponentPanelUser
              panelUser={panelUser}
              loading={loading}
              institucionales={paginasInst}
              portadas={portadas}
              submitAction={handlePanelUser}
            />
          </CardContent>
        </Card>
    </PageContainer>
  );
};

export default FormPanelUser;
